module.exports = {"id":"168950","name":"Sami Allagui","rating":"72","photo":"./data/images/photos/0/168950.png","club":{"name":"FC St. Pauli","logo":"./data/images/clubs/FCSt.Pauli.png"},"positions":["BU","MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SamiAllagui0.json
// module id = 3795
// module chunks = 0